import { render } from "./Karekok.vue?vue&type=template&id=555c1b9a"
import script from "./Karekok.vue?vue&type=script&lang=js"
export * from "./Karekok.vue?vue&type=script&lang=js"

import "./Karekok.vue?vue&type=style&index=0&id=555c1b9a&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__